export const OFFLINE_ERROR_PAGE_DELAY_MS = 750;

// Items type
export const ITEMS_TYPE_CUSTOMER_ITEMS = "ITEMS_TYPE_CUSTOMER_ITEMS";
export const ITEMS_TYPE_SHARED_BOARD = "ITEMS_TYPE_SHARED_BOARD";
export const ITEMS_TYPE_SIMILAR = "ITEMS_TYPE_SIMILAR";

// Access levels
export const ACCESS_LEVEL_VIEW = "view";
export const ACCESS_LEVEL_PURCHASE = "purchase";

export const ONE_LINK_BASE_URL = "https://asos-medialabs.onelink.me/PXyX";
